import { render, staticRenderFns } from "./switch_monitor.vue?vue&type=template&id=37b5d0b5&"
import script from "./switch_monitor.vue?vue&type=script&lang=js&"
export * from "./switch_monitor.vue?vue&type=script&lang=js&"
import style0 from "./switch_monitor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports